import {urls} from '../urls'
export const promoCodeService = urls.developmentUrl + ':5017/'
// export const promoCodeService = "https://f79d3e39e253.ngrok.io/"


export const promoCodeUrls = {
  postPromoCode: promoCodeService + 'promo/code/save',
  getPromoCodes: promoCodeService + 'promo/code/active',
  getActivePromoCodes: promoCodeService + 'promo/code/active/valid',
  makePromoCodeActive: promoCodeService + 'promo/code/alter/status/active/',
  makePromoCodeInActive: promoCodeService + 'promo/code/alter/status/inactive/',
  getInActivePromoCodes: promoCodeService + 'promo/code/inactive',
  getPromoCode: promoCodeService + 'promo/code/',
  deletePromoCode: promoCodeService + 'promo/code/delete/',
  editPromoCode: promoCodeService + 'promo/code/alter/',
  getAllPromoCodes: promoCodeService + 'promo/code/active/valid',
  restorePromoCode: promoCodeService + 'starts/restore/',
  getDeletedPromoCode: promoCodeService + 'starts/deleted',
  getPromoCodeUsage: promoCodeService + 'promo/code/use/'
}

export const promoCodeTypeUrls = {
  postPromoCodeType: promoCodeService + 'promo/code/type/save',
  getPromoCodeTypes: promoCodeService + 'promo/code/types',
  getPromoCodeType: promoCodeService + 'promo/code/type/',
  deletePromoCodeType: promoCodeService + 'promo/code/type/delete/',
  editPromoCodeType: promoCodeService + 'promo/code/type/alter/',
  getAllPromoCodeTypes: promoCodeService + 'promo/code/types',
  restorePromoCodeType: promoCodeService + 'starts/restore/',
  getDeletedPromoCodeType: promoCodeService + 'starts/deleted'
}
